import { render, staticRenderFns } from "./salary-upload-dialog.vue?vue&type=template&id=1596fc02&scoped=true&"
import script from "./salary-upload-dialog.vue?vue&type=script&lang=js&"
export * from "./salary-upload-dialog.vue?vue&type=script&lang=js&"
import style0 from "./salary-upload-dialog.vue?vue&type=style&index=0&id=1596fc02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596fc02",
  null
  
)

export default component.exports